export const MODULE_NAME = '@pressreader/sponsorship-core';
